import { useLicensingServiceV1 } from "@rw1/api-services";
import { Licensing_V1 } from "@rw1/auto-generated-clients";
import { STALE_TIME_MS } from "../../../hooks/constants";
import { LICENSE_ALLOCATIONS_QUERY_KEY } from "../../../hooks/useExternalExperiences";
import { useFetchAll } from "../../../hooks/useFetchAll"; // Import generic hook

export const useLicenseUsers = (
  licenseId: string | undefined,
): {
  users: Licensing_V1.LicenseUserAllocation[];
  isLoading: boolean;
} => {
  const licensingService = useLicensingServiceV1();

  const { data: users = [], isLoading: isLicensesLoading } =
    useFetchAll<Licensing_V1.LicenseUserAllocation>(
      [LICENSE_ALLOCATIONS_QUERY_KEY, licenseId],
      (page, size) =>
        licensingService.getLicenseUserAllocations(licenseId!, page, size),
      {
        enabled: !!licenseId,
        staleTime: STALE_TIME_MS,
        select: (allItems) => allItems.filter((item) => !item.isRevoked),
      },
    );

  return {
    users,
    isLoading: isLicensesLoading,
  };
};
